<template>
	<div>
		<navTitle>
			<div class="flex flex-align-center flex-jus-center">
				<div class="selectCenter flex flex-align-center flex-jus-center" @click="resourcesPopShow = true">
					<span>{{majorName ? majorName : '请选择'}}</span>
					<img src="@/static/images/icon-arrowRight2.png" alt="" />
				</div>
			</div>
		</navTitle>

		<div class="officeTag flex flex-align-center">
			<div @click="changeType(item.id)" v-for="item in typeList" :key="item.id" class="officeTag-tag" :class="{'officeTag-tagActive': category_id == item.id}">{{item.name}}</div>
			<div class="flexStation"></div>
		</div>
		<van-list
			v-model="loading"	
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<div class="officeList">
				<office v-for="item in organizationList" :info="item" :type="2" :key="item.id"></office>
			</div>
		</van-list>
		
		<resourcesPop :majorId="majorId" :resourcesPopShow.sync="resourcesPopShow" @changeResourcesPop="changeResourcesPop"></resourcesPop>
	</div>
</template>

<script>
import office from '@/views/components/office.vue';
import resourcesPop from '@/views/components/resourcesPop.vue';
/* eslint-disable */
export default {
	components: {
		office,
		resourcesPop
	},
	data() {
		return {
			resourcesPopShow: false,
			page: 1,
			majorId: '',
			majorName: '',
			typeList: [],
			category_id: '',
			organizationList: [],
			loading: false,
      finished: false
		};
	},
	created() {
		this.majorId = localStorage.getItem('majorId') || ''
		this.majorName = localStorage.getItem('majorName') || ''
		this.getCategoryType()
		this.getOrganization()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '推荐机构',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		// 推荐机构分类
		getCategoryType() {
			this.$get('api/actile/getLearningResourceOrganizationCategory').then(res => {
				this.typeList = [{
					name: '全部',
					id: ''
				}, ...res.data]
			})
		},
		// 推荐机构
		getOrganization() {
			this.$get('api/actile/getLearningResourceOrganizationList', {
				category_id: this.category_id,
				major_id: this.majorId,
				lat: localStorage.getItem('latitude'),
				lng: localStorage.getItem('longitude'),
				page: this.page,
				pageSize: 10
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
				this.organizationList.splice((this.page - 1) * 10, 10, ...rows)
			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getOrganization();
      }
		},
		changeType(id) {
			this.category_id = id
			this.organizationList = []
			this.getOrganization()
		},
		changeResourcesPop(data) {
			this.majorId = data.id
			this.majorName = data.name
			localStorage.setItem('majorId', this.majorId)
			localStorage.setItem('majorName', this.majorName)
			this.resourcesPopShow = false
			this.page = 1
			this.getOrganization()
		}
	}
};
</script>

<style scoped lang="stylus">
.selectCenter
	margin 0 auto
	min-width 160px
	height 64px
	border 2px solid #FFFFFF
	border-radius 38px
	font-size 28px
	color #FFFFFF
	padding 0 12px
	span
		word-break keep-all
	img
		margin-left 8px
		width 12px
		height 22px
.officeTag
	position fixed
	width 100vw
	background-color #FFFFFF
	padding 28px 0px 28px 30px
	overflow-x auto
	font-size: 28px;
	color: #000000;
	.officeTag-tagActive
		color: #DE113C;
		border: 2px solid #DE113C !important;
	.officeTag-tag
		min-width: 164px;
		padding 6px 20px
		text-align center
		height: 52px;
		border: 2px solid #B1B1B1;
		border-radius: 26px;
		margin-right 40px
	.flexStation
		flex 0 0 1px
		height 1px
		
.officeList
	margin-top 120px
	padding 0 30px
</style>
